import { Injectable } from '@angular/core';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { PopupConfirmComponent } from 'src/app/shared/popup-confirm/popup-confirm.component';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  constructor(private dialog: MatDialog) { }

  deleteDialog(data: string){
    let dialogRef: MatDialogRef<PopupConfirmComponent>;
    dialogRef = this.dialog.open(PopupConfirmComponent);
    dialogRef.componentInstance.data = data;

    return dialogRef.afterClosed();
  }

  private getExtension(filename: string) {
    const parts = filename.split('.');
    return parts[parts.length - 1];
  }

  isImage(filename: string) {
    const ext = this.getExtension(filename);
    switch (ext.toLowerCase()) {
      case 'jpg':
      case 'gif':
      case 'bmp':
      case 'png':
        //etc
        return true;
    }
    return false;
  }
}
